const binding = { modules: {}, dataActions: {} };

    (binding.modules['sign-up'] = {
        c: () => require('partner/modules/sign-up/sign-up.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'sign-up',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/sign-up'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|sign-up|sign-up'] = {
                c: () => require('partner/modules/sign-up/sign-up.view.tsx'),
                cn: '__local__-__local__-sign-up'
            };
viewDictionary['@msdyn365-commerce-modules|account-management|modules|sign-up|sign-up'] = {
                c: () => require('@msdyn365-commerce-modules/account-management/dist/lib/modules/sign-up/sign-up.view.js'),
                cn: '@msdyn365-commerce-modules-account-management-sign-up'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };